<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';
import NextInput from 'next/input/Input.vue';
import WithLabel from 'v3/components/Form/WithLabel.vue';

const { t } = useI18n();
const isEnabled = ref(false);
const messageTemplate = ref('');

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { assignment_welcome_message_enabled, assignment_welcome_message } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!assignment_welcome_message_enabled;
    messageTemplate.value = assignment_welcome_message || '';
  },
  { deep: true, immediate: true }
);

const save = async () => {
  try {
    await updateAccount({
      assignment_welcome_message_enabled: isEnabled.value,
      assignment_welcome_message: messageTemplate.value.trim() || null,
    });
    useAlert(t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.API.SUCCESS'));
  } catch {
    useAlert(t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.API.ERROR'));
  }
};

const onToggle = () => save();
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="onToggle" />
      </div>
    </template>

    <div v-if="isEnabled" class="mt-4">
      <WithLabel
        :label="t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.MESSAGE_LABEL')"
      >
        <NextInput
          v-model="messageTemplate"
          class="w-full"
          :placeholder="
            t('GENERAL_SETTINGS.FORM.ASSIGNMENT_WELCOME.MESSAGE_PLACEHOLDER')
          "
          @blur="save"
        />
      </WithLabel>
    </div>
  </SectionLayout>
</template>
